export enum AuthFlow {
  SignUp = 'signUp',
  SignIn = 'signIn',
  PhoneOnly = 'phone',
  ProfileOnly = 'profile',
}

export enum AuthEntryPoint {
  AuthPage = 'auth page',
  Artist = 'artist',
  DrawEntry = 'draw entry',
  Event = 'event',
  Release = 'release page',
  NavBar = 'nav bar',
  NewsletterFooter = 'newsletter footer',
  NewsletterHomepage = 'newsletter homepage',
  NewsletterInsights = 'newsletter insights',
  NftWallet = 'nft wallet',
  PreOrder = 'pre-order',
  Product = 'product',
  AML = 'aml verification page',
  AuctionEntry = 'auction entry',
  InstitutionsPage = 'institutions page',
  PrintmakingPage = 'printmaking page',
}
